// 環境に非依存な定数をここに定義する
// 例：システム共通のプレフィックス値など
const constant = {
  "s3_tenant_prefix": "tenant",
}

export default constant;